import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import HomeCarouselItem from './HomeCarouselItem';

import './css/Carousel.css';
import { useMediaQuery } from 'react-responsive';

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

  const desc1 = `Kate the Chemist is back with a bang to share her new book "It's Elemental: The Hidden Chemistry in Everything".`

function HomeCarousel() {
    // return false;
    const isMobile = useMediaQuery({ query: `(max-width: 960px)` });
    return (
        <div className={isMobile ? "carousel-main-mobile" : "carousel-main"}>
            <Carousel
            swipeable={false}
            draggable={false}
            showDots={false}
            responsive={responsive}
            ssr={false} // means to render carousel on server-side.
            infinite={true}
            // autoPlay={this.props.deviceType !== "mobile" ? true : false}
            autoPlay={true}
            autoPlaySpeed={6000}
            keyBoardControl={true}
            // customTransition="all .5"
            transitionDuration={1000}
            containerclassName="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            // deviceType={this.props.deviceType}
            dotListclassName="custom-dot-list-style"
            itemclassName="carousel-item-padding-40-px"
            sliderclassName="carousel-slider"
            renderDotsOutside
            >
                <HomeCarouselItem 
                    videoUrl="9m0xY3Yp3dI"
                    description={desc1}
                />

                <HomeCarouselItem 
                    videoUrl="J0rw35qiJtM"
                    description="Danni Washington joins Kate Biberdorf 'Kate the Chemist' to see how science can be magic!
                    Mission Unstoppable with Miranda Cosgrove celebrates women who have become superstars in STEM-related careers.
                    " 
                />

                <HomeCarouselItem 
                    videoUrl="9W9DCSABs2U"
                    description="College professor Kate Biberdorf, also known as Kate the Chemist, sits down with supermodel Karlie Kloss to talk about how her demonstrations are fueling the next generation of chemists." 
                />

                <HomeCarouselItem 
                    videoUrl="VdrkMOr9Xp4"
                    description="Kate the Chemist fires up the crowd at TEDxDetroit about science, STEM education, evidence-based​ conversations and inspiring the next generation of women scientists." 
                />

                <HomeCarouselItem 
                    videoUrl="2xVBAqybA_8"
                    description="Scientist and author Kate Biberdorf (perhaps better known as Kate The Chemist), answers the internet's burning questions about chemistry.
                    " 
                />
                


                
            </Carousel>
        </div>
    );
}

export default HomeCarousel;
